import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lang-wrapper" }
const _hoisted_2 = { class: "lang-title" }

import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { MicroAppCacheKey } from '@/enums/microAppCacheKey';
import { getTimezone } from '@/utils/tools';

// 定义时区项类型

const __default__ = {
  name: 'LocaltimePicker'
};

interface LocaltimeItem {
  value: string;
  label: string;
  itemValue: string;
  itemCode: string;
  attr2?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();

// 当前选择时区：从 store getUserTimeZone 获取
const currLocaltime = computed(() => store.getters['microAppCache/getUserTimeZone'] || '');

// 时区列表：从 store 按 key 取字典，转 { value, label } 并追加 Local
const localtimeList = computed<LocaltimeItem[]>(() => {
  const getDictByKey = store.getters['microAppCache/getDictByKey'] as (key: string) => any;
  const raw = getDictByKey(MicroAppCacheKey.UserTimeZone);
  if (!Array.isArray(raw)) return [];
  return raw.map((item: any) => ({
    ...item,
    label: item.itemValue,
    value: item.itemCode
  })).concat({ label: 'Local', value: 'Local', itemValue: '', itemCode: '' });
});

// 计算属性：当前时区标签
const currLocaltimeLabel = computed(() => {
  const foundItem = localtimeList.value.find(item => item.value === currLocaltime.value);
  return foundItem?.label || currLocaltime.value || '';
});

// 切换时区
const handleChangeLocaltime = (val: string) => {
  store.commit('microAppCache/setUserTimeZone', val);
  location.reload();
};

// 未设置时区则设置默认时区（有列表优先 attr2，否则 getTimezone）
watch(
  [localtimeList, currLocaltime],
  () => {
    if (!store.state.user?.userInfo) return;
    if (!currLocaltime.value) {
      const defaultTimeZone = localtimeList.value.find(item => item.attr2)?.value || getTimezone();
      store.commit('microAppCache/setUserTimeZone', defaultTimeZone);
    }
  },
  { immediate: true }
);


return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (localtimeList.value.length)
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        onCommand: handleChangeLocaltime,
        "popper-class": "lang-dropdown",
        trigger: "click",
        size: "default"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localtimeList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: item.value,
                  command: item.value,
                  disabled: item.value === currLocaltime.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["command", "disabled"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(currLocaltimeLabel.value), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "arrow-down" }, null, -1))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})